import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { KpisService } from 'src/app/component/kpis/kpis-service/kpis.service';

@Component({
  selector: 'app-add-expense-modal',
  templateUrl: './add-expense-modal.component.html',
  styleUrls: ['./add-expense-modal.component.css']
})
export class AddExpenseModalComponent implements OnInit, OnDestroy {
  modalFlagTest:any;
  addExpenseForm: UntypedFormGroup;
  @Input() addExpenseModal:boolean = false;
  @Output() onCloseExpenseModal =  new EventEmitter<any>();
  kpisExpense:any


  

  constructor(
    private kpiService:KpisService,
    private fb: UntypedFormBuilder) {

    }

  ngOnInit() {
    this.addExpenseForm = this.fb.group({
      amount: ['', Validators.required],
      description: ['', Validators.required],
     
  
    });
  }

  onSubmit(){
    this.kpiService.saveDriverBreakDownExpense(this.addExpenseForm)
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(data=>{
      if(data){
        this.kpisExpense = data;
      }
    })
    
  }


  onCloseModal(){
    this.onCloseExpenseModal.emit(false);
  }


  ngOnDestroy(): void {
  }
}
